import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import TopHeader from './TopHeader';
import WelcomeTour from './WelcomeTour';

export default function AppShell() {
  return (
    <div className="min-h-screen flex bg-[#F2EFE7]">
      <Sidebar />
      <div className="flex-1 flex flex-col min-w-0">
        <TopHeader />
        <main className="flex-1 p-6 md:p-8 min-w-0">
          <Outlet />
        </main>
      </div>
      <WelcomeTour />
    </div>
  );
}
